
@switch (componentType) {
  @default {
    <div class="filter-option">
      <input class="search-box form-control" [(ngModel)]="searchTerm" [placeholder]="placeholder" />
    </div>
  }
  @case ('BOOLEAN') {
    <fn-grid-check-select-filter [eventFilter]="eventFilter"></fn-grid-check-select-filter>
  }
  @case ('NUM') {
    <div class="filter-option">
      InRange
    </div>
    <ul class="filter-list-item">
      <li>
        <div class="form-check">
          <input class="search-box form-control" fnNumberDirective [isDecimal]="'true'" [isNegative]="true" [(ngModel)]="numFrom" placeholder="From" />
        </div>
      </li>
      <li>
        <div class="form-check">
          <input class="search-box form-control" fnNumberDirective [isDecimal]="'true'" [isNegative]="true" [(ngModel)]="numTo" placeholder="TO" />
        </div>
      </li>
    </ul>
  }
}
<div class="filter-action">
  <span class="'filter-apply'">
    <button class="btn btn-sm btn-primary" (click)="searchOnRowsByCol()">Apply Filter</button>
  </span>
  <span class="'filter-reset'">
    <button class="btn btn-sm btn-primary" (click)="reset()">Reset Filter</button>
  </span>
</div>